'use strict';
import {STATE_CHANGE_ERROR, STATE_CHANGE_START, STATE_CHANGE_SUCCESS} from 'redux-ui-router/lib/action-types';
import {Observable} from 'rxjs/Observable';
import {AbstractEpics} from '../../core-utilities/redux/AbstractEpics';
import {epicErrorHandler, noActionsEmitted} from '../../core-utilities/rx-utils';
import {logger} from './logger';


/**
 * Exported for unit testing
 */
export class NavigationUtilityEpics extends AbstractEpics {
  /**
   * @param options
   */
  constructor(options) {
    super(options);

    this.requestFactory = options.requestFactory;

    this.onNavBlockClicks = this.onNavBlockClicks.bind(this);
    this.addEpic(this.onNavBlockClicks);

    this.onNavBlockClicks.$inject = [
      '$ionicClickBlock',
    ];
  }

  /**
   * @param {ActionsObservable<ReduxAction>} action$
   * @param {Store} store
   * @param dependencies
   */
  onNavBlockClicks(action$, store, dependencies) {
    return action$.ofType(STATE_CHANGE_START)
      .switchMap(() =>
        new Observable(observer => {
          const $ionicClickBlock = dependencies.$ionicClickBlock;

          $ionicClickBlock.show(/* autoExpire */ 2000);
          observer.next({});

          return () => {
            $ionicClickBlock.hide();
          };
        })
      )
      .takeUntil(
        Observable.combineLatest(
          // Always way at least 500ms for the animation transition to complete.
          Observable.timer(500),
          // Wait for the transition to succeed, fail, or the max delay
          Observable
            .merge(
              action$.ofType(STATE_CHANGE_SUCCESS),
              action$.ofType(STATE_CHANGE_ERROR),
              Observable.timer(2000) // wait no more than 2 seconds for laggy transitions
            ),
        )
      )
      .filter(noActionsEmitted)
      .catch(epicErrorHandler(this.logger, 'UserLogAppInfoEpics.onSendRequest'));
  }
}

export const navigationUtilityEpics = new NavigationUtilityEpics({
  logger,
}).epics;



// WEBPACK FOOTER //
// ./src/js/system/epics/onNavBlockClicks.js